import { ValidatorsModel } from '@ng-stack/forms';

export interface ValidationIncorrectInputModel extends ValidatorsModel {
  incorrectInput: { value: boolean };
}
